import script from "./CustomTabBar.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomTabBar.vue?vue&type=script&setup=true&lang=js"

import "./CustomTabBar.vue?vue&type=style&index=0&id=3d778558&scoped=true&lang=css"

import exportComponent from "/Users/norman/Code/aerocle-project/aerocle_client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d778558"]])

export default __exports__